import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {graphql, Link} from 'gatsby'
import './Grid.scss'
import Button from '../Button/Button'
import advokater from '../../assets/svg/icons/ikon-people.svg'
import buildings from '../../assets/svg/icons/ikon-buildings.svg'
import town_hall from '../../assets/svg/icons/ikon-townhallsvg.svg'
import student from '../../assets/svg/icons/ikon-student.svg'

const Icon = ({icon}) => {

	const chooseIcon = () => {
		switch(icon) {
			case 'People': {
				return <img src={advokater} alt={icon} />
			}
			case 'Buildings': {
				return <img src={buildings} alt={icon} />
			}
			case 'Town Hall': {
				return <img src={town_hall} alt={icon} />
			}
			case 'Student': {
				return <img src={student} alt={icon} />
			}
			default: {
				return null
			}
		}
	}

	return(
		<div className="Icon">
			{chooseIcon()}
		</div>
	)
}

const Item = ({title, heading, text, icon, image, button, id}) => {
	return(
		<div className="GridItem">
			{
				image
				?
					button
						? <Link to={button.url}><GatsbyImage image={getImage(image.localFile.childImageSharp)} alt={title ? title : ''} /></Link>
						: <GatsbyImage image={getImage(image.localFile.childImageSharp)} alt={title ? title : ''} />
				: null
			}
			<div className="content">
				{
					icon
					? <Icon icon={icon} />
					: null
				}
				{ title && <p className="title" id={id} dangerouslySetInnerHTML={{__html: title}} /> }
				{ heading && <h3 dangerouslySetInnerHTML={{__html: heading}} />}
				{ text && <div className="text" dangerouslySetInnerHTML={{__html: text}} /> }
				{ button && <Button label={id} {...button} color="primary" /> }
			</div>
		</div>
	)
}

export default function Grid({items, id}) {
	return(
		<div className="Grid">
			{
				items.map((item, i) => <Item key={`${id}_${i}`} id={`${id}_${i}`} {...item} />)
			}
		</div>
	)
}

export const query = graphql`
	fragment Grid on WpPage_Layout_block_Layout_Grid {
		fieldGroupName
		items {
			button {
				target
				title
				url
			}
			icon
			image {
				altText
				localFile {
					childImageSharp {
						gatsbyImageData(
							width: 600,
							height: 400,
							quality: 80,
							placeholder: DOMINANT_COLOR
						)
					}
				}
			}
			text
			title
			heading
		}
	}
`